import { Navigate } from 'react-router-dom';

import { FCC, useToast } from '@eluve/components';
import { useSession } from '@eluve/session-helpers';

export const EvalGuard: FCC = ({ children }) => {
  const session = useSession();
  const toast = useToast();

  if (!session.isEluveEvalUser) {
    toast.error('Access denied');
    return <Navigate to="/" replace />;
  }

  return children;
};
